module.exports = __webpack_public_path__ + "img/main-lg.bed2515d.jpg";